export default __webpack_public_path__ + "static/media/expoindo-3.0b13ad32.jpg";